/**
 * Centralized contact email addresses for Zaruvia.
 * Update here — changes propagate across the entire codebase.
 */

export const CONTACTS = {
  /** General questions, refunds, partnerships */
  general:   "hola@zaruvia.com",
  /** Advertising and media inquiries */
  ads:       "publicidad@zaruvia.com",
  /** Technical support, bug reports, data requests */
  support:   "soporte@zaruvia.com",
} as const;
